import { enumType } from '@shared/core/types/common';

enum ENERGY_UNITS {
    CALS = OLO.Enums.ENERGY_UNITS.CALS,
    KILOJOULES = OLO.Enums.ENERGY_UNITS.KILOJOULES,
}

export const energyUnitsEnum = enumType('ENERGY_UNITS', ENERGY_UNITS);
